import Vue from 'vue';

Vue.mixin({
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.$samitoEvents.runEvent('start');
        });
        next();
    },
    beforeRouteLeave(to, from, next) {
        next((vm) => {
            vm.$samitoEvents.runEvent('stop');
        });
        next();
    },
});
